import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";

export default function useTimeOnPractice() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const mapped = res.data.timeSpendDetails.map((item) => ({
        Subject: item._id.name,
        Time:
          parseInt(item.timeSpend / 3600) +
          parseInt(item.timeSpend % 3600),
      }));
      setData(mapped);
    }
  };

  return { data, loading, fetchData };
}